import { Association, Opportunity, OrganizationManager } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { ISSUE_TYPE } from "@shared/helpers/constants";
import { Fields, Relations } from "remult";
import { OpportunityReportEntityConfig } from "./config";
import { OpportunityReportFilters } from "./filters";
import { OpportunityReportMethods } from "./methods";

@HyperEntity("opportunity-report", OpportunityReportEntityConfig)
export class OpportunityReport extends extender(
  OpportunityReportFilters,
  OpportunityReportMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "opportunity_id" })
  opportunityId = "";

  @Relations.toOne<OpportunityReport, Opportunity>(() => Opportunity, {
    field: "opportunityId",
    caption: "פרטי המשימה",
  })
  opportunity?: Opportunity;

  @Fields.string({ dbName: "association_id" })
  associationId = "";

  @Relations.toOne<OpportunityReport, Association>(() => Association, {
    fields: { id: "associationId" },
    caption: "פרטי משתמש/ת",
  })
  association?: Association;

  @Fields.string({ dbName: "organization_manager_id", allowNull: true })
  organizationManagerId?: string;

  @Relations.toOne<OpportunityReport, OrganizationManager>(
    () => OrganizationManager,
    {
      field: "organizationManagerId",
    },
  )
  organizationManager?: OrganizationManager;

  @Fields.boolean({ dbName: "is_negative_experience" })
  isNegativeExperience = false;

  @Fields.boolean({ dbName: "is_goal_achieved" })
  isGoalAchieved = false;

  @Fields.string({ dbName: "issue_description", allowNull: true })
  issueDescription?: string;

  @Fields.literal(() => ISSUE_TYPE, {
    dbName: "issue_type",
    allowNull: true,
  })
  issueType?: (typeof ISSUE_TYPE)[number];

  @Fields.boolean({ dbName: "is_manager_handled" })
  isManagerHandled = false;

  @Fields.createdAt<OpportunityReport>({
    caption: "נוצר בתאריך",
    dbName: "created_at",
    displayValue: (v) => v.createdAt.toLocaleDateString("he"),
  })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
